import React from "react";
import { useTranslation } from "react-i18next";
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Typography, Button, CircularProgress, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";

// Shows the not-yet-saved PDF (watermarked "PREVIEW" server-side, see
// controllers/salesDocument.js previewDocumentPdf) so staff can review before
// committing — confirming is the only action that actually creates the
// document and advances the doc-number sequence (see CreateTab.jsx).
// `onSaveDraft` — optional; saves the reviewed form as a draft instead of
// issuing it (no doc number consumed).
const PreviewDialog = ({ open, pdfUrl, isConfirming, onClose, onConfirm, onSaveDraft, isSavingDraft }) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth PaperProps={{ sx: { height: "90vh" } }}>
      <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <Typography variant="h6" color="secondary">{t("salesDocuments.previewTitle")}</Typography>
        <IconButton onClick={onClose}><CloseIcon /></IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0 }}>
        {pdfUrl ? (
          <Box component="iframe" src={pdfUrl} title="preview" sx={{ width: "100%", height: "100%", border: "none" }} />
        ) : (
          <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
            <CircularProgress color="secondary" />
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ p: "14px 20px" }}>
        <Button variant="outlined" color="secondary" onClick={onClose}>{t("salesDocuments.backToEdit")}</Button>
        {onSaveDraft && (
          <Button
            variant="outlined" color="secondary"
            startIcon={<SaveOutlinedIcon />}
            disabled={isSavingDraft || isConfirming}
            onClick={onSaveDraft}
          >
            {t("salesDocuments.saveDraft")}
          </Button>
        )}
        <Button
          variant="contained" color="secondary"
          startIcon={<CheckCircleOutlineIcon />}
          disabled={!pdfUrl || isConfirming}
          onClick={onConfirm}
        >
          {isConfirming ? <CircularProgress size={20} color="inherit" /> : t("salesDocuments.confirmGenerate")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PreviewDialog;
